import {
  ICustomerItem,
  IOrderItem,
} from "../../../../../modules/API/Drivers/models/kavData";

export interface IDriversTotals {
  weight: number;
  pallets: number;
}

/**
 * Суммирует вес и паллеты по теудот.
 * Теуда с непустым PalletsList считается по Gross/PallQty, иначе по Weight/Pallets.
 */
export const aggregateOrders = (orders: IOrderItem[]): IDriversTotals =>
  orders.reduce<IDriversTotals>(
    (acc, order) => {
      if (order.PalletsList.length === 0) {
        acc.weight += order.Weight;
        acc.pallets += order.Pallets;
        return acc;
      }
      acc.weight += order.PalletsList.reduce((sum, pallet) => sum + pallet.Gross, 0);
      acc.pallets += order.PalletsList.reduce((sum, pallet) => sum + pallet.PallQty, 0);
      return acc;
    },
    { weight: 0, pallets: 0 }
  );

/**
 * Суммирует вес и паллеты по клиентам.
 * excludeReturns (по умолчанию true) пропускает клиентов Type === 1 (רכש) —
 * так считает уровень кава.
 */
export const aggregateCustomers = (
  customers: ICustomerItem[],
  options?: { excludeReturns?: boolean }
): IDriversTotals => {
  const excludeReturns = options?.excludeReturns ?? true;
  return customers.reduce<IDriversTotals>(
    (acc, customer) => {
      if (excludeReturns && customer.Type === 1) return acc;
      const { weight, pallets } = aggregateOrders(customer.Orders);
      acc.weight += weight;
      acc.pallets += pallets;
      return acc;
    },
    { weight: 0, pallets: 0 }
  );
};
